import React from 'react';

function Education(){
    return (
        <div className="container_resume">
            <div>
                <p style={{fontSize: "30px"}}>Education</p>
            </div>
            <div style={{textAlign: "left"}}>
                <p>2022 - 2023</p>
            </div>
            <div style={{textAlign: "left", fontWeight: "bold"}}>
                <p>University of Utah | <br/>Master of Software Development</p>
            </div>

            <div>
                <p style={{fontSize: "30px"}}></p>
            </div>
            <div style={{textAlign: "left"}}>
                <p>2014 - 2016</p>
            </div>
            <div style={{textAlign: "left", fontWeight: "bold"}}>
                <p>National Taiwan University | <br/>MS in Construction Management, Civil Engineering</p>
            </div>

            <div>
                <p style={{fontSize: "30px"}}></p>
            </div>
            <div style={{textAlign: "left"}}>
                <p>2014 - 2016</p>
            </div>
            <div style={{textAlign: "left", fontWeight: "bold"}}>
                <p>National Taiwan University | <br/>BS in Civil Engineering</p>
            </div>
        </div>
    );
}

function WorkingExprience(){
    return (
        <div className="container_resume">
            <div>
                <p style={{fontSize: "30px"}}>Working Experience</p>
            </div>
            <div style={{textAlign: "left"}}>
                <p>2023 - Present</p>
            </div>
            <div style={{textAlign: "left", fontWeight: "bold"}}>
                <p>University of Utah | <br/>Instructional Staff</p>
            </div>

            <div>
                <p style={{fontSize: "30px"}}></p>
            </div>
            <div style={{textAlign: "left"}}>
                <p>2023 - 2023</p>
            </div>
            <div style={{textAlign: "left", fontWeight: "bold"}}>
                <p>Kinetic Technologies | <br/>Software Engineering Intern</p>
            </div>

            <div>
                <p style={{fontSize: "30px"}}></p>
            </div>
            <div style={{textAlign: "left"}}>
                <p>2021 - 2022</p>
            </div>
            <div style={{textAlign: "left", fontWeight: "bold"}}>
                <p>Zebra Technologies | <br/>NPI Program Manager</p>
            </div>

            <div>
                <p style={{fontSize: "30px"}}></p>
            </div>
            <div style={{textAlign: "left"}}>
                <p>2021 - 2022</p>
            </div>
            <div style={{textAlign: "left", fontWeight: "bold"}}>
                <p>Pegatron Corporation | <br/>Engineering Project Manager</p>
            </div>
        </div>
    );

}

function Skills() {
    return (
        <div className="container_resume">
            <div>
                <p style={{fontSize: "30px"}}>Skills</p>
            </div>
            <div style={{textAlign: "left", fontWeight: "bold"}}>
                <p></p>
            </div>
            <div style={{textAlign: "left"}}>
                <p style={{fontWeight: "bold"}}>Programming Languages</p>
                <p>Java, C++/C, Python, JavaScript, Kotlin, C#, SQL, HTML/CSS</p>
            </div>

            <div>
                <p style={{fontSize: "30px"}}></p>
            </div>
            <div style={{textAlign: "left", fontWeight: "bold"}}>
                <p></p>
            </div>
            <div style={{textAlign: "left"}}>
                <p style={{fontWeight: "bold"}}>Developer Tools</p>
                <p>MySQL, AWS, D3.js, Git, Unix, Qt, Firebase...</p>
            </div>
            <div>
                <p style={{fontSize: "30px"}}></p>
            </div>
            <div style={{textAlign: "left", fontWeight: "bold"}}>
                <p></p>
            </div>
            <div style={{textAlign: "left"}}>
                <p style={{fontWeight: "bold"}}>Frameworks</p>
                <p>React, Node.js, Express.js, Flask...</p>
            </div>
        </div>


    );
}

function Resume() {
    return (
        <div className="header">
            <h1 style={{fontSize: "50px"}}>Resume</h1>
            <Skills/>
            <hr width="1100px"/>
            <Education/>
            <hr width="1100px"/>
            <WorkingExprience/>

        </div>


    )
        ;
}

export default Resume;